import { ReactNode } from "react";
import { Box, SxProps, Theme, Typography } from "@mui/material";
import { FORM_STATUS_ENUM } from "@interfaces/response";
import { ChipEstadoExpediente } from "./ChipEstadoExpediente";

interface Props {
  /** Encabezado principal de la sección, con el mismo estilo que ExpProcessRow. */
  heading: string;
  /** Chip de estado opcional. Si se omite, no se renderiza. */
  status?: FORM_STATUS_ENUM;
  /** Contenido libre debajo del encabezado. */
  children: ReactNode;
  /** Overrides sobre el contenedor externo. */
  sx?: SxProps<Theme>;
}

/**
 * Encabezado de sección con el mismo estilo visual que ExpProcessRow,
 * pero con contenido libre (children) en lugar de la franja de acción fija.
 */
export const ExpSectionRow = ({ heading, status, children, sx }: Props) => (
  <Box sx={sx}>
    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "12px", mb: "14px" }}>
      <Typography variant="body1" sx={{ fontWeight: 600, letterSpacing: "-0.015em", color: "primary.dark" }}>
        {heading}
      </Typography>
      {status && <ChipEstadoExpediente formStatus={status} />}
    </Box>
    {children}
  </Box>
);
